import { observer } from 'mobx-react';
import { useEffect } from 'react';

import { Checkbox, Input } from '@gamesb42/ui-kit';
import { appInfoInst } from '.';

// Типы для MMP сервисов
type MMPService = keyof typeof appInfoInst.values.mmp;

// Список MMP сервисов с человекочитаемыми названиями
const MMP_OPTIONS: { key: MMPService; label: string }[] = [
  { key: 'adjust', label: 'Adjust' },
  { key: 'appsflyer', label: 'Appsflyer' },
  { key: 'tenjin', label: 'Tenjin' },
  { key: 'kochava', label: 'Kochava' },
  { key: 'branch', label: 'Branch' },
  { key: 'firebase', label: 'Firebase' },
  { key: 'dontKnow', label: "I don't know" },
  { key: 'other', label: 'Other' },
];

// Переиспользуемый компонент для MMP сервиса
const MMPOptionComponent = observer(
  ({
    serviceKey,
    label,
    checked,
    onToggle,
  }: {
    serviceKey: MMPService;
    label: string;
    checked: boolean;
    onToggle: (serviceKey: MMPService, checked: boolean) => void;
  }) => (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        height: '24px', // Фиксированная высота для выравнивания
      }}
    >
      <Checkbox
        checked={checked}
        onChange={(e) => onToggle(serviceKey, e.target.checked)}
      >
        {label}
      </Checkbox>
    </div>
  ),
);

const Step4 = observer(() => {
  useEffect(() => {
    // ИСПРАВЛЕННАЯ валидация - проверяем что хотя бы один сервис выбран
    appInfoInst.isStepIsValid[4] = Object.values(appInfoInst.values.mmp).some(
      (el) => el === true,
    );
  }, [
    appInfoInst.values.mmp.adjust,
    appInfoInst.values.mmp.appsflyer,
    appInfoInst.values.mmp.tenjin,
    appInfoInst.values.mmp.kochava,
    appInfoInst.values.mmp.branch,
    appInfoInst.values.mmp.firebase,
    appInfoInst.values.mmp.dontKnow,
    appInfoInst.values.mmp.other,
  ]);

  // Функция для переключения MMP сервиса
  const toggleMMPService = (serviceKey: MMPService, checked: boolean) => {
    if (serviceKey === 'otherComment') return; // Защита от изменения комментария
    appInfoInst.values.mmp[serviceKey] = checked;
  };

  return (
    <>
      <h3>
        <b>Your current MMP (tracking service)*</b>
      </h3>

      <div
        style={{
          marginTop: '20px',
          display: 'flex',
          flexDirection: 'column',
          gap: '32px',
        }}
      >
        {MMP_OPTIONS.map(({ key, label }) => (
          <MMPOptionComponent
            key={key}
            serviceKey={key}
            label={label}
            checked={Boolean(appInfoInst.values.mmp[key])}
            onToggle={toggleMMPService}
          />
        ))}
      </div>

      {/* Поле для комментария к Other */}
      {appInfoInst.values.mmp.other && (
        <div style={{ marginTop: '20px' }}>
          <Input
            size="large"
            label="Enter your MMP (tracking service)"
            value={appInfoInst.values.mmp.otherComment}
            onChange={(e) => {
              appInfoInst.values.mmp.otherComment = e.target.value;
            }}
          />
        </div>
      )}
    </>
  );
});

export default Step4;
